import { render, staticRenderFns } from "./OnboardingConfirmContributionPage.vue?vue&type=template&id=e2bd7186"
import script from "./OnboardingConfirmContributionPage.vue?vue&type=script&lang=ts"
export * from "./OnboardingConfirmContributionPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports